import React, { FC, useMemo } from "react";
import { Route, Switch, useLocation } from "react-router";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ScrollTop from "../../../../../components/ScrollToTop";
import { AdapterLink } from "../../../../../components/Adopter";
import Error from "../../../../../components/Error";
import AcademicsPageSecondary from "../../../../academic/pages/AcademicsPageSecondary";
import AcademicsPageHigher from "../../../../academic/pages/AcademicsPageHigher";
import BranchesPage from "../../../../branch/components/BranchesPage";
import { EducationType } from "../../../../school/constants/types";
import { useUserAccount } from "../../context";
import { SchoolStudentsPage } from "../../../../student/pages/SchoolStudentsPage";
import { SchoolStudentAccountPage } from "../../../../student/pages/SchoolStudentAccountPage";
import BillingPage from "../../../../billing/pages/BillingPage";
import { Routes } from "../../../../../constants/routes";
import MessagesPageWrapper from "../../../../message/MessagesPageWrapper";
import { UserRole } from "../../../enums/UserRole";
import { useAuth } from "../../../../auth/hooks/useAuth";
import LanguageCoursesPage from "../../../../language-course/pages/LanguageCoursesPage";
import ServicesPage from "../../../../services/pages/ServicesPage";

const useStyles = makeStyles(() => ({
  tabs: {
    marginTop: 24,
    marginBottom: 14,
  },
  tabLink: {
    "&:hover": {
      textDecoration: "none",
    },
  },
  root: {
    minWidth: 0,
    padding: "6px 16px",
  },
}));

const ServiceProvider: FC = () => {
  const classes = useStyles();
  const { user: authUser } = useAuth();

  const {
    userIsAuthUser,
    path,
    user,
    profile: { data: { data: profile = null } = {} },
  } = useUserAccount();
  const { pathname } = useLocation();
  const pieces = pathname.split(`${path}`);
  const tabRoute = pieces[pieces.length - 1]
    .replace(/^\/|\/$/g, "")
    .split("/")[0];
  const currentRoute = "/0/user/:userId/edit";
  const isAdmin = [UserRole.Owner, UserRole.Admin].includes(authUser?.role);

  const tabs = useMemo(() => {
    let list: any[] = [];

    if (profile.serviceProvider) {
      list.push({
        label: "Services",
        component: ServicesPage,
        path: "",
      });

      if (isAdmin) {
        list.push({
          label: "Messages",
          component: () => (
            <MessagesPageWrapper serviceProviderUserId={user?.id} />
          ),
          path: `/${Routes.MESSAGES}`,
        });
      }
    }

    return list;
  }, [userIsAuthUser]);

  if (!tabs.length) return null;

  const routes = [] as any;

  tabs.forEach((tab) => {
    routes.push({
      exact: true,
      path: tab.path,
      component: tab.component,
    });

    if (tab.children) {
      tab.children.forEach((subTab) => {
        routes.push({
          exact: false,
          path: tab.path + subTab.path,
          component: subTab.component,
        });
      });
    }
  });

  return (
    <>
      <Tabs value={tabRoute} variant="scrollable" className={classes.tabs}>
        {tabs.map((item, index) => (
          <Tab
            component={AdapterLink}
            className={clsx(classes.tabLink, classes.root)}
            key={index}
            label={item.label}
            value={item.path.replace(/^\/|\/$/g, "")}
            to={path + item.path}
          />
        ))}
      </Tabs>
      <Switch>
        {routes.map((item, index) => (
          <Route
            key={index}
            exact={item.exact}
            path={currentRoute + item.path}
            component={item.component}
          />
        ))}
        <Route
          path={`${currentRoute}/*`}
          component={() => <Error text={"Not found"} />}
        />
      </Switch>
      <ScrollTop threshold={200} />
    </>
  );
};

export default ServiceProvider;
